<template>
<!-- 合同详情页 -->
  <div>
    <navigation-bar></navigation-bar>
    <div class="main">
      <el-row>
        <!-- 左侧导航栏 -->
        <el-col :span="4">
          <div class="sidebar">
            <div class="sidebar_title">合同管理</div>
            <div class="sidebar_item" :class="{active:true}">
              我的合同
            </div>
          </div>
        </el-col>
        <!-- 内容 -->
        <el-col :span="16">
          <div class="content">
            <div class="con_title"><span class="el-icon-arrow-left" @click="backContractPage"></span>合同详情</div>
            <div class="con_details">
              <div class="con_detail">
                <i>创建时间：</i>
                <span>{{createTime}}</span>
              </div>
              <div class="con_detail right">
                <i>到期时间：</i>
                <span>{{expirationTime}}</span>
              </div>
            </div>
            <!-- <div class="con_details">
              <div class="con_detail">
                <i>创建时间：</i>
                <span>2022-04-02  12:00:03</span>
              </div>
              <div class="con_detail right">
                <i>购买时长：</i>
                <span>1年</span>
              </div>
            </div> -->
            <!-- table -->
            <div class="table">
              <el-table
                :data="tableData"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                default-expand-all
                :header-cell-style="{background:'rgba(233, 239, 255, 1)',color:'#2A2A2A'}"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <el-table-column
                  label="合同号"
                  min-width="130">
                  <template slot-scope="scope">
                    {{scope.row.contractId}}
                    <el-popover
                      popper-class="copy_hint"
                      placement="right"
                      width="40"
                      trigger="click">
                      <div>复制成功</div>
                      <i slot="reference" class="el-icon-copy-document copy_btn" @click="copyNumber(scope.row.contractId)"></i>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="合同名称">
                </el-table-column>
                <el-table-column
                  prop="price"
                  label="产品单价">
                </el-table-column>
                <el-table-column
                  prop="totalPrice"
                  label="应付总额">
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="操作"
                  min-width="110">
                  <div class="action_buttons"><i @click="dialogVisible=true">查看合同</i>
                  |<i @click="downloadContract">下载电子合同</i>
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <!-- dialog -->
            <el-dialog :visible.sync="dialogVisible" center width="50%">
              <!-- title -->
              <template slot="title">
                  <div class="dialog_title">合同</div>
              </template>
              <!-- body -->
              <div class="dialog_mian">
                <iframe :src="pdfUrl+'#toolbar=0'" width="100%" height="100%" frameborder="0"></iframe>
              </div>
              <!-- footer -->
              <span slot="footer" class="dialog-footer">
                <div class="confirm_button" @click="downloadContract">下载电子合同</div>
                <div @click="dialogVisible=false">取消</div>
              </span>
            </el-dialog>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import NavigationBar from '../../../components/console/navigationBar.vue'
// import axios from 'axios'
export default {
  components: {
    NavigationBar
  },
  data() {
    return {
      createTime: '',
      expirationTime: '',
      documentId: '',
      detailData: {},
      tableData :[],
      // dialog
      dialogVisible: false,
      pdfUrl: '',
    }
  },
 created() {
   this.getData();
 },
  methods: {
    getData() {
      if(this.$route.query.data) {
        //拿到传递过来的数据，一个对象
        this.detailData = JSON.parse(this.$route.query.data);
        // console.log(this.detailData);
        this.createTime = this.detailData.createTime.substring(0, this.detailData.createTime.length - 5);//创建时间
        this.expirationTime = this.detailData.expirationTime.substring(0, this.detailData.expirationTime.length - 3);//到期时间
        this.documentId = this.detailData.documentId;//合同id
        this.pdfUrl = this.detailData.fileUrl;//合同pdfurl
        this.tableData.push(this.detailData);//转换成表格数据
        // console.log(this.pdfUrl);
      }
    },
    //回到合同首页
    backContractPage() {
      this.$router.push({path: '/contractManagement'})
    },
    //下载合同
    downloadContract() {
      // let params = {
      //   documentId: this.documentId,
      //   appId: '',
      //   appName: '',
      //   channelId: '',
      //   clientId: '',
      //   clientIp: '',
      //   countryCode: '',
      //   currency: '',
      //   locale: '',
      //   nickName: '',
      //   repeatCode: '',
      //   sessionId: '',
      //   sign: '',
      //   tagId: '',
      //   timeZone: '',
      //   timestamp: '',
      //   userId: '',
      //   versionCode: ''
      // }
      // axios({
      //   method: 'POST',
      //   url: 'http://121.37.136.73:40002/contract/downloadContractDocument',
      //   params: {
      //     ...params
      //   },
      // }).then(res => {
      //   console.log('下载电子合同-----------');
      //   console.log(res.data.data);
      //   // this.fileLinkToStreamDownload('api/upload/pdf/PDFDemo.pdf')
      // })
      let str = this.pdfUrl;
      let string = str.substring(str.indexOf("u")-1)
      let url = 'api'+ string;
      this.fileLinkToStreamDownload(url);
    },
    fileLinkToStreamDownload(url) {
      let fileName = '电子合同'
      let xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      xhr.setRequestHeader('Content-Type', `application/pdf`)
      xhr.responseType = 'blob'
      let that = this
      xhr.onload = function() {
        if (this.status == 200) {
          //接受二进制文件流
          var blob = this.response
          that.downloadExportFile(blob, fileName)
        }
      }
      xhr.send()
    },
    downloadExportFile(blob, tagFileName) {
      let downloadElement = document.createElement('a')
      let href = blob
      if (typeof blob == 'string') {
        downloadElement.target = '_blank'
      } else {
        href = window.URL.createObjectURL(blob) //创建下载的链接
      }
      downloadElement.href = href
      downloadElement.download = tagFileName + ''//下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() //点击下载
      document.body.removeChild(downloadElement) //下载完成移除元素
      if (typeof blob != 'string') {
        window.URL.revokeObjectURL(href) //释放掉blob对象
      }
    },
    //复制订单号
    copyNumber(text) {
      var input = document.createElement("input");
      input.value = text; // 修改文本框的内容
      document.body.appendChild(input);
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      document.body.removeChild(input)
    },
  }
}
</script>

<style lang="scss" scoped="scoped">
.main {
  margin-top: 80px;
  .sidebar {
    width: 80%;
    height: 1200px;
    color: #4F4F4F;
    border-right: 1px solid #E5E5E5;
    .sidebar_title {
        height: 79px;
        border-bottom: 1px solid #E5E5E5;
        text-align: center;
        line-height: 79px;
    }
    .sidebar_item {
      height: 47px;
      font-size: 14px;
      text-align: center;
      line-height: 47px;
    }
    .active {
      background-color: #F8F9FF;
      color: #537EEE;
      border-right: 4px solid #537EEE;
    }
    .sidebar_item:hover {
      cursor: pointer;
      background-color: #F8F9FF;
      color: #537EEE;
    }
  }
  .content {
    padding: 20px 20px 100px;
    margin-top: 20px;
    border: 1px solid #E5E5E5;
    .con_title {
      padding-bottom: 20px;
      color: #4F4F4F;
      span {
        margin-right: 18px;
        color: #5984EC;
      }
      span:hover {
        cursor: pointer;
      }
    }
    .con_details {
      position: relative;
      margin-top: 20px;
      .con_detail {
        font-size: 12px;
        i {
          margin-right: 15px;
          font-style: normal;
          color: #AAA;
        }
        span {
          color: #4F4F4F;
        }
      }
      .right {
        position: absolute;
        top: 0;
        left: 25%;
      }
    }
    .table {
      .copy_btn {
        margin-left: 5px;
      }
      .copy_btn:hover {
        cursor: pointer;
      }
      .el-table {
        margin: 50px 0;
        font-size: 12px;
        /deep/ th {
            padding: 4px;
            font-weight: 400;
        }
        /deep/ td {
            padding: 10px;
        }
        /deep/ .cell {
          overflow: visible;
        }
      }
      .action_buttons {
        color: #E5E5E5;
        i {
          margin: 0 8px;
          font-style: normal;
          color: #507DF1;
        }
        i:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
    /deep/ .el-dialog {
      height: 669px;
      .dialog_title {
        height: 68px;
        background-color: #E9EFFF;
        font-size: 20px;
        color: #507DF1;
        text-align: center;
        line-height: 68px;
      }
      // main
      .dialog_mian {
        height: 487px;
        border: 1px solid #E6E6E6;
        // overflow-y: auto;
      }
      // footer
      .dialog-footer {
        display: flex;
        justify-content: center;
        margin: 30px 0 20px;
        div {
          width: 25%;
          height: 30px;
          margin-right: 10px;
          border: 1px solid #E5E5E5;
          font-size: 14px;
          color: #4F4F4F;
          text-align: center;
          line-height: 32px;
        }
        div:hover {
          cursor: pointer;
        }
        .confirm_button {
          background-color: #C12B31;
          color: #fff;
        }
      }
    }
    /deep/ .el-dialog--center .el-dialog__body {
      padding: 0;
    }
    /deep/ .el-dialog__header {
      padding: 0;
    }
  }
}
</style>